const socialData = [
  {
    id: 1,
    cls: "social-item",
    href: "https://www.facebook.com/HTUjo/",
    iconClass: "fa-brands fa-facebook-f",
    alt: "Facebook",
  },
  {
    id: 2,
    cls: "social-item social-twitter",
    href: "https://x.com/htujo/",
    iconClass: "fa-brands fa-x-twitter",
    alt: "Twitter X",
    twitter: true,
  },
  {
    id: 3,
    cls: "social-item",
    href: "https://www.instagram.com/htujo/",
    iconClass: "fa-brands fa-instagram",
    alt: "instagram",
  },
  {
    id: 4,
    cls: "social-item",
    href: "https://www.linkedin.com/school/al-hussein-technical-university-htu/",
    iconClass: "fa-brands fa-linkedin-in",
    alt: "LinkedIn",
  },
  {
    id: 5,
    cls: "social-item",
    href: "https://www.youtube.com/channel/UC-DXAAHuMg7k7mss7uFskzQ",
    iconClass: "fa-brands fa-youtube",
    alt: "YouTube",
  },
  {
    id: 6,
    cls: "social-item",
    href: "https://answers.mawdoo3.com/category/%D8%AC%D8%A7%D9%85%D8%B9%D8%A9-%D8%A7%D9%84%D8%AD%D8%B3%D9%8A%D9%86-%D8%A7%D9%84%D8%AA%D9%82%D9%86%D9%8A%D8%A9",
    iconClass: "fa-solid fa-question",
    alt: "Mawdoo3",
  },
  {
    id: 6,
    cls: "social-item",
    href: "https://login.microsoftonline.com/?whr=htu.edu.jo",
    iconClass: "fa-brands fa-windows",
    alt: "Microsoft Online",
  },
];

export default function FooterSocial() {
  return (
    <>
      {socialData.map((item, index) => (
        <a
          aria-label={item.alt}
          key={item.id + index}
          className={item.cls}
          href={item.href || "#"}
          target="_blank"
        >
          {item.twitter ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="14"
              viewBox="0 0 512 512"
              className="svg-twitter"
            >
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
            </svg>
          ) : (
            <i className={item.iconClass}></i>
          )}
        </a>
      ))}
    </>
  );
}
